import { z } from 'zod';

export const EventAttendanceDto = z.object({
  userId: z.uuid(),
  eventId: z.uuid(),
  createdAt: z.iso.datetime(),
});
export type EventAttendanceDto = z.infer<typeof EventAttendanceDto>;

export const EventAttendeesQuery = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(50).default(20),
});
export type EventAttendeesQuery = z.infer<typeof EventAttendeesQuery>;

export const EventAttendeeDto = z.object({
  id: z.uuid(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  username: z.string().nullable(),
  photoUrl: z.string().nullable(),
  status: z.enum(['CONFIRMED', 'WAITLISTED']),
  /** Время отметки на входе (#147, задача 1); null — не отмечен или билета нет. */
  checkedInAt: z.iso.datetime().nullable(),
  /** Только для admin-viewer; иначе omit. */
  energyAvailable: z.number().int().min(0).optional(),
});
export type EventAttendeeDto = z.infer<typeof EventAttendeeDto>;

export const EventAttendeesResponse = z.object({
  items: z.array(EventAttendeeDto),
  nextCursor: z.string().nullable(),
});
export type EventAttendeesResponse = z.infer<typeof EventAttendeesResponse>;
